import { css, Theme } from '@emotion/react';
import { List, ListItemIcon, ListItemText } from '@mui/material';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { NavListItemSymbol } from 'shared/components/symbols';

const listItemContainerCss = css`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

const containerCss = (theme: Theme) => css`
  min-width: 20rem;
  border-bottom: solid 1px;
  border-bottom-color: ${theme.palette.divider};
`;

export type SettingsSidebarItem = {
  title: string;
  icon: string | ReactNode;
  route: string;
};

interface SettingsSidebarProps {
  items: SettingsSidebarItem[];
}

export function SettingsSidebar({ items }: SettingsSidebarProps) {
  const location = useLocation();

  return (
    <List css={containerCss}>
      {items.map(item => (
        <NavListItemSymbol
          css={listItemContainerCss}
          key={item.route}
          path={item.route}
          selected={location.pathname === item.route}
          button
          disableGutters
          startIcon={<ListItemIcon>{item.icon}</ListItemIcon>}
          listItemText={<ListItemText disableTypography={false}>{item.title}</ListItemText>}
        />
      ))}
    </List>
  );
}
